var _path, _circle, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobilitiDc50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7754 12.381C23.7754 19.0592 18.3892 25.4557 12.0022 29.7286C5.1603 24.9922 0.224609 19.0629 0.224609 12.381C0.224609 5.66052 5.5032 0.224609 12 0.224609C18.4968 0.224609 23.7754 5.66052 23.7754 12.381Z",
    fill: "#FFC20E",
    stroke: "#408E8D",
    strokeWidth: 0.449219
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 11.25,
    r: 8.25,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2212 9.61133L15.5725 15.5846L16.0731 13.0508L18.4382 12.1844L12.2212 9.61133Z",
    fill: "#408E8D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7027 12.1846H6L7.88142 13.8978L7.42751 16.4381L12.7027 12.1846Z",
    fill: "#ABE1FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.413 11.3266L13.7643 5.35551L11.3823 6.17609L9.47119 4.5L10.413 11.3266Z",
    fill: "#FFC20E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilitiDc50);
export default __webpack_public_path__ + "static/media/mobiliti_dc50.f4d7a3cef9662f1b21160f26adb04d72.svg";
export { ForwardRef as ReactComponent };